export const modalObj = (flag, message) => {
  return {flg: flag, message: message};
};
